// extracted by mini-css-extract-plugin
export var details = "_ls-0";
export var inspectorPopover = "_ls-1";